/* NEXORA — Collectible effects + scroll reveal.
   Holographic cards tilt toward the cursor (desktop) or the device (mobile gyroscope),
   the way a real refractor catches the light. Everything is off under reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Holographic tilt ── */
  function bindHolo(card) {
    if (card.dataset.nxHoloBound) return;
    card.dataset.nxHoloBound = 'true';
    var holo = card.querySelector('.nx-fx__holo');
    var max = 16;

    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      card.style.transform =
        'perspective(800px) rotateY(' + ((px - 0.5) * max).toFixed(2) + 'deg) rotateX(' +
        ((0.5 - py) * max).toFixed(2) + 'deg) translateY(-6px)';
      if (holo) holo.style.backgroundPosition = Math.round(px * 100) + '% ' + Math.round(py * 100) + '%';
    });

    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  }

  function initHolo(root) {
    (root || document).querySelectorAll('.nx-fx--card').forEach(bindHolo);
  }
  initHolo();

  /* Mobile: the whole grid of cards reacts to how you tilt the phone. */
  var tiltCards = [];
  function collectTilt() { tiltCards = [].slice.call(document.querySelectorAll('.nx-fx--card')); }
  collectTilt();

  if (window.DeviceOrientationEvent && 'ontouchstart' in window) {
    window.addEventListener('deviceorientation', function (e) {
      if (!tiltCards.length || e.gamma == null || e.beta == null) return;
      var gx = Math.max(-1, Math.min(1, e.gamma / 30));
      var gy = Math.max(-1, Math.min(1, (e.beta - 45) / 30));
      var pos = Math.round((gx + 1) * 50) + '% ' + Math.round((gy + 1) * 50) + '%';
      tiltCards.forEach(function (c) {
        var holo = c.querySelector('.nx-fx__holo');
        if (holo) { holo.style.opacity = '.85'; holo.style.backgroundPosition = pos; }
        c.style.transform = 'perspective(800px) rotateY(' + (gx * 7).toFixed(1) + 'deg) rotateX(' + (-gy * 5).toFixed(1) + 'deg)';
      });
    }, { passive: true });
  }

  /* ── Scroll reveal: sections rise into place as you reach them ── */
  var targets = document.querySelectorAll('[data-nx-reveal]:not([data-nx-reveal="none"])');
  if (targets.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nx-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('nx-revealed'); });
  }

  document.addEventListener('shopify:section:load', function (e) {
    initHolo(e.target);
    collectTilt();
    e.target.querySelectorAll('[data-nx-reveal]').forEach(function (t) { t.classList.add('nx-revealed'); });
  });
})();

/* ── Tunnel parallax: the stadium corridor drifts as you scroll. ── */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var tunnel = document.querySelector('.nx-stadium-hero__tunnel');
  if (!tunnel) return;
  var ticking = false;
  function update() {
    var y = window.scrollY || 0;
    tunnel.style.setProperty('--nx-parallax', (y * 0.14).toFixed(1) + 'px');
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* ── L'ARÈNE VIVANTE ────────────────────────────────────────────────────────
   Génère les projecteurs, la foule et la poussière.
   Allège automatiquement sur mobile / petit appareil : l'émotion reste,
   le téléphone ne chauffe pas. Respecte prefers-reduced-motion.          */
(() => {
  const build = (arena) => {
    if (arena.dataset.nxArenaReady === 'true') return;
    arena.dataset.nxArenaReady = 'true';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    const light = window.innerWidth < 750 || (navigator.hardwareConcurrency || 8) <= 4;
    const LAMPS = 5;
    const CROWD = light ? 70 : 170;
    const DUST = light ? 10 : 26;

    const rig = arena.querySelector('[data-nx-arena-rig]');
    const beams = arena.querySelector('[data-nx-arena-beams]');
    for (let i = 0; i < LAMPS; i += 1) {
      if (rig) {
        const lamp = document.createElement('span');
        lamp.className = 'nx-arena__lamp';
        lamp.style.animationDuration = `${2.6 + i * 0.4}s`;
        lamp.style.animationDelay = `${i * 0.3}s`;
        rig.appendChild(lamp);
      }
      if (beams && !light) {
        const beam = document.createElement('span');
        beam.className = 'nx-arena__beam';
        beam.style.left = `${18 + i * 15}%`;
        beam.style.animationDuration = `${11 + i * 2.3}s`;
        beam.style.animationDelay = `${i * 1.4}s`;
        beams.appendChild(beam);
      }
    }

    const crowd = arena.querySelector('[data-nx-arena-crowd]');
    if (crowd) {
      const frag = document.createDocumentFragment();
      for (let i = 0; i < CROWD; i += 1) {
        const s = document.createElement('span');
        s.className = 'nx-arena__spark';
        const r = Math.random();
        s.style.background = r > 0.75 ? 'rgb(var(--color-button))' : r > 0.5 ? '#cfe6ff' : '#8fa8c4';
        s.style.left = `${(Math.random() * 100).toFixed(1)}%`;
        s.style.top = `${(Math.random() * 100).toFixed(1)}%`;
        s.style.animationDuration = `${(1.8 + Math.random() * 3.4).toFixed(1)}s`;
        s.style.animationDelay = `${(Math.random() * 4).toFixed(1)}s`;
        frag.appendChild(s);
      }
      crowd.appendChild(frag);
    }

    const dust = arena.querySelector('[data-nx-arena-dust]');
    if (dust) {
      const frag = document.createDocumentFragment();
      for (let i = 0; i < DUST; i += 1) {
        const d = document.createElement('span');
        d.className = 'nx-arena__mote';
        const green = Math.random() > 0.45;
        d.style.background = green ? 'rgba(var(--color-button), .9)' : 'rgba(255,255,255,.75)';
        d.style.boxShadow = `0 0 6px ${green ? 'rgba(var(--color-button), .8)' : 'rgba(210,235,255,.6)'}`;
        d.style.left = `${(14 + Math.random() * 72).toFixed(1)}%`;
        d.style.bottom = `${(6 + Math.random() * 32).toFixed(1)}%`;
        d.style.animationDuration = `${(10 + Math.random() * 12).toFixed(1)}s`;
        d.style.animationDelay = `${(Math.random() * 12).toFixed(1)}s`;
        frag.appendChild(d);
      }
      dust.appendChild(frag);
    }
  };

  const init = (scope = document) => scope.querySelectorAll('[data-nx-arena]').forEach(build);

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
